/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  BirthdayDto,
  CreateEmployeeDto,
  EmployeeDetailDto,
  EmployeeListItemDto,
  EmployeesControllerBirthdaysV1Params,
  EmployeesControllerSetPhotoV1Body,
  OrgChartNodeDto,
  PhotoUrlDto,
  SetModeratorDto,
  SetRoleDto,
  UpdateEmployeeDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export interface employeesControllerListV1Response200 {
  data: EmployeeListItemDto[]
  status: 200
}

export type employeesControllerListV1ResponseSuccess = (employeesControllerListV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerListV1Response = (employeesControllerListV1ResponseSuccess)

export const getEmployeesControllerListV1Url = () => {




  return `/api/v1/employees`
}

/**
 * @summary Справочник сотрудников
 */
export const employeesControllerListV1 = async ( options?: RequestInit): Promise<employeesControllerListV1Response> => {

  return apiRequest<employeesControllerListV1Response>(getEmployeesControllerListV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getEmployeesControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesControllerListV1>>, TError,void, TContext> => {

const mutationKey = ['employeesControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesControllerListV1>>, void> = () => {


          return  employeesControllerListV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof employeesControllerListV1>>>

    export type EmployeesControllerListV1MutationError = unknown

    /**
 * @summary Справочник сотрудников
 */
export const useEmployeesControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof employeesControllerListV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEmployeesControllerListV1MutationOptions(options), queryClient);
    }
    export interface employeesControllerCreateV1Response200 {
  data: EmployeeDetailDto
  status: 200
}

export type employeesControllerCreateV1ResponseSuccess = (employeesControllerCreateV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerCreateV1Response = (employeesControllerCreateV1ResponseSuccess)

export const getEmployeesControllerCreateV1Url = () => {




  return `/api/v1/employees`
}

/**
 * @summary Создать сотрудника (админ)
 */
export const employeesControllerCreateV1 = async (createEmployeeDto: CreateEmployeeDto, options?: RequestInit): Promise<employeesControllerCreateV1Response> => {

  return apiRequest<employeesControllerCreateV1Response>(getEmployeesControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEmployeeDto)
  }
);}





export const getEmployeesControllerCreateV1QueryKey = (createEmployeeDto?: MaybeRef<CreateEmployeeDto>,) => {
    return [
    'POST', 'api','v1','employees', createEmployeeDto
    ] as const;
    }


export const getEmployeesControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerCreateV1>>, TError = unknown>(createEmployeeDto: MaybeRef<CreateEmployeeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerCreateV1QueryKey(createEmployeeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerCreateV1>>> = ({ signal }) => employeesControllerCreateV1(unref(createEmployeeDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerCreateV1>>, TError, TData>
}

export type EmployeesControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerCreateV1>>>
export type EmployeesControllerCreateV1QueryError = unknown


/**
 * @summary Создать сотрудника (админ)
 */

export function useEmployeesControllerCreateV1<TData = Awaited<ReturnType<typeof employeesControllerCreateV1>>, TError = unknown>(
 createEmployeeDto: MaybeRef<CreateEmployeeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerCreateV1QueryOptions(createEmployeeDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerOrgChartV1Response200 {
  data: OrgChartNodeDto[]
  status: 200
}

export type employeesControllerOrgChartV1ResponseSuccess = (employeesControllerOrgChartV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerOrgChartV1Response = (employeesControllerOrgChartV1ResponseSuccess)

export const getEmployeesControllerOrgChartV1Url = () => {




  return `/api/v1/employees/org-chart`
}

/**
 * @summary Схема подчинения (дерево)
 */
export const employeesControllerOrgChartV1 = async ( options?: RequestInit): Promise<employeesControllerOrgChartV1Response> => {

  return apiRequest<employeesControllerOrgChartV1Response>(getEmployeesControllerOrgChartV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getEmployeesControllerOrgChartV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerOrgChartV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesControllerOrgChartV1>>, TError,void, TContext> => {

const mutationKey = ['employeesControllerOrgChartV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesControllerOrgChartV1>>, void> = () => {


          return  employeesControllerOrgChartV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesControllerOrgChartV1MutationResult = NonNullable<Awaited<ReturnType<typeof employeesControllerOrgChartV1>>>

    export type EmployeesControllerOrgChartV1MutationError = unknown

    /**
 * @summary Схема подчинения (дерево)
 */
export const useEmployeesControllerOrgChartV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerOrgChartV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof employeesControllerOrgChartV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEmployeesControllerOrgChartV1MutationOptions(options), queryClient);
    }
    export interface employeesControllerBirthdaysV1Response200 {
  data: BirthdayDto[]
  status: 200
}

export type employeesControllerBirthdaysV1ResponseSuccess = (employeesControllerBirthdaysV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerBirthdaysV1Response = (employeesControllerBirthdaysV1ResponseSuccess)

export const getEmployeesControllerBirthdaysV1Url = (params?: EmployeesControllerBirthdaysV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/employees/birthdays?${stringifiedParams}` : `/api/v1/employees/birthdays`
}

/**
 * @summary Ближайшие дни рождения
 */
export const employeesControllerBirthdaysV1 = async (params?: EmployeesControllerBirthdaysV1Params, options?: RequestInit): Promise<employeesControllerBirthdaysV1Response> => {

  return apiRequest<employeesControllerBirthdaysV1Response>(getEmployeesControllerBirthdaysV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}




export const getEmployeesControllerBirthdaysV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>, TError,{params?: EmployeesControllerBirthdaysV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>, TError,{params?: EmployeesControllerBirthdaysV1Params}, TContext> => {

const mutationKey = ['employeesControllerBirthdaysV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>, {params?: EmployeesControllerBirthdaysV1Params}> = (props) => {
          const {params} = props ?? {};

          return  employeesControllerBirthdaysV1(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesControllerBirthdaysV1MutationResult = NonNullable<Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>>

    export type EmployeesControllerBirthdaysV1MutationError = unknown

    /**
 * @summary Ближайшие дни рождения
 */
export const useEmployeesControllerBirthdaysV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>, TError,{params?: EmployeesControllerBirthdaysV1Params}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof employeesControllerBirthdaysV1>>,
        TError,
        {params?: EmployeesControllerBirthdaysV1Params},
        TContext
      > => {
      return useMutation(getEmployeesControllerBirthdaysV1MutationOptions(options), queryClient);
    }
    export interface employeesControllerGetByIdV1Response200 {
  data: EmployeeDetailDto
  status: 200
}

export type employeesControllerGetByIdV1ResponseSuccess = (employeesControllerGetByIdV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerGetByIdV1Response = (employeesControllerGetByIdV1ResponseSuccess)

export const getEmployeesControllerGetByIdV1Url = (id: string,) => {




  return `/api/v1/employees/${id}`
}

/**
 * @summary Карточка сотрудника
 */
export const employeesControllerGetByIdV1 = async (id: string, options?: RequestInit): Promise<employeesControllerGetByIdV1Response> => {

  return apiRequest<employeesControllerGetByIdV1Response>(getEmployeesControllerGetByIdV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getEmployeesControllerGetByIdV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetByIdV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['employeesControllerGetByIdV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesControllerGetByIdV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  employeesControllerGetByIdV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesControllerGetByIdV1MutationResult = NonNullable<Awaited<ReturnType<typeof employeesControllerGetByIdV1>>>

    export type EmployeesControllerGetByIdV1MutationError = unknown

    /**
 * @summary Карточка сотрудника
 */
export const useEmployeesControllerGetByIdV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetByIdV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof employeesControllerGetByIdV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEmployeesControllerGetByIdV1MutationOptions(options), queryClient);
    }
    export interface employeesControllerUpdateV1Response200 {
  data: EmployeeDetailDto
  status: 200
}

export type employeesControllerUpdateV1ResponseSuccess = (employeesControllerUpdateV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerUpdateV1Response = (employeesControllerUpdateV1ResponseSuccess)

export const getEmployeesControllerUpdateV1Url = (id: string,) => {




  return `/api/v1/employees/${id}`
}

/**
 * @summary Изменить сотрудника (админ)
 */
export const employeesControllerUpdateV1 = async (id: string,
    updateEmployeeDto: UpdateEmployeeDto, options?: RequestInit): Promise<employeesControllerUpdateV1Response> => {

  return apiRequest<employeesControllerUpdateV1Response>(getEmployeesControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateEmployeeDto)
  }
);}





export const getEmployeesControllerUpdateV1QueryKey = (id: MaybeRef<string>,
    updateEmployeeDto?: MaybeRef<UpdateEmployeeDto>,) => {
    return [
    'PATCH', 'api','v1','employees',id, updateEmployeeDto
    ] as const;
    }


export const getEmployeesControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerUpdateV1>>, TError = unknown>(id: MaybeRef<string>,
    updateEmployeeDto: MaybeRef<UpdateEmployeeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerUpdateV1QueryKey(id,updateEmployeeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerUpdateV1>>> = ({ signal }) => employeesControllerUpdateV1(unref(id),unref(updateEmployeeDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerUpdateV1>>, TError, TData>
}

export type EmployeesControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerUpdateV1>>>
export type EmployeesControllerUpdateV1QueryError = unknown


/**
 * @summary Изменить сотрудника (админ)
 */

export function useEmployeesControllerUpdateV1<TData = Awaited<ReturnType<typeof employeesControllerUpdateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    updateEmployeeDto: MaybeRef<UpdateEmployeeDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerUpdateV1QueryOptions(id,updateEmployeeDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerRemoveV1Response204 {
  data: void
  status: 204
}

export type employeesControllerRemoveV1ResponseSuccess = (employeesControllerRemoveV1Response204) & {
  headers: Headers;
};
;

export type employeesControllerRemoveV1Response = (employeesControllerRemoveV1ResponseSuccess)

export const getEmployeesControllerRemoveV1Url = (id: string,) => {




  return `/api/v1/employees/${id}`
}

/**
 * @summary Удалить сотрудника (админ)
 */
export const employeesControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<employeesControllerRemoveV1Response> => {

  return apiRequest<employeesControllerRemoveV1Response>(getEmployeesControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getEmployeesControllerRemoveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','employees',id
    ] as const;
    }


export const getEmployeesControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerRemoveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerRemoveV1>>> = ({ signal }) => employeesControllerRemoveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveV1>>, TError, TData>
}

export type EmployeesControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerRemoveV1>>>
export type EmployeesControllerRemoveV1QueryError = unknown


/**
 * @summary Удалить сотрудника (админ)
 */

export function useEmployeesControllerRemoveV1<TData = Awaited<ReturnType<typeof employeesControllerRemoveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerSetRoleV1Response200 {
  data: void
  status: 200
}

export type employeesControllerSetRoleV1ResponseSuccess = (employeesControllerSetRoleV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerSetRoleV1Response = (employeesControllerSetRoleV1ResponseSuccess)

export const getEmployeesControllerSetRoleV1Url = (id: string,) => {




  return `/api/v1/employees/${id}/role`
}

/**
 * @summary Назначить глобальную роль (админ)
 */
export const employeesControllerSetRoleV1 = async (id: string,
    setRoleDto: SetRoleDto, options?: RequestInit): Promise<employeesControllerSetRoleV1Response> => {

  return apiRequest<employeesControllerSetRoleV1Response>(getEmployeesControllerSetRoleV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setRoleDto)
  }
);}





export const getEmployeesControllerSetRoleV1QueryKey = (id: MaybeRef<string>,
    setRoleDto?: MaybeRef<SetRoleDto>,) => {
    return [
    'PATCH', 'api','v1','employees',id,'role', setRoleDto
    ] as const;
    }


export const getEmployeesControllerSetRoleV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerSetRoleV1>>, TError = unknown>(id: MaybeRef<string>,
    setRoleDto: MaybeRef<SetRoleDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetRoleV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerSetRoleV1QueryKey(id,setRoleDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerSetRoleV1>>> = ({ signal }) => employeesControllerSetRoleV1(unref(id),unref(setRoleDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetRoleV1>>, TError, TData>
}

export type EmployeesControllerSetRoleV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerSetRoleV1>>>
export type EmployeesControllerSetRoleV1QueryError = unknown


/**
 * @summary Назначить глобальную роль (админ)
 */

export function useEmployeesControllerSetRoleV1<TData = Awaited<ReturnType<typeof employeesControllerSetRoleV1>>, TError = unknown>(
 id: MaybeRef<string>,
    setRoleDto: MaybeRef<SetRoleDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetRoleV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerSetRoleV1QueryOptions(id,setRoleDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerAddModeratorV1Response201 {
  data: void
  status: 201
}

export type employeesControllerAddModeratorV1ResponseSuccess = (employeesControllerAddModeratorV1Response201) & {
  headers: Headers;
};
;

export type employeesControllerAddModeratorV1Response = (employeesControllerAddModeratorV1ResponseSuccess)

export const getEmployeesControllerAddModeratorV1Url = (id: string,) => {




  return `/api/v1/employees/${id}/moderator`
}

/**
 * @summary Назначить модератором модуля (админ)
 */
export const employeesControllerAddModeratorV1 = async (id: string,
    setModeratorDto: SetModeratorDto, options?: RequestInit): Promise<employeesControllerAddModeratorV1Response> => {

  return apiRequest<employeesControllerAddModeratorV1Response>(getEmployeesControllerAddModeratorV1Url(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setModeratorDto)
  }
);}





export const getEmployeesControllerAddModeratorV1QueryKey = (id: MaybeRef<string>,
    setModeratorDto?: MaybeRef<SetModeratorDto>,) => {
    return [
    'POST', 'api','v1','employees',id,'moderator', setModeratorDto
    ] as const;
    }


export const getEmployeesControllerAddModeratorV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>, TError = unknown>(id: MaybeRef<string>,
    setModeratorDto: MaybeRef<SetModeratorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerAddModeratorV1QueryKey(id,setModeratorDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>> = ({ signal }) => employeesControllerAddModeratorV1(unref(id),unref(setModeratorDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>, TError, TData>
}

export type EmployeesControllerAddModeratorV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>>
export type EmployeesControllerAddModeratorV1QueryError = unknown


/**
 * @summary Назначить модератором модуля (админ)
 */

export function useEmployeesControllerAddModeratorV1<TData = Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>, TError = unknown>(
 id: MaybeRef<string>,
    setModeratorDto: MaybeRef<SetModeratorDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerAddModeratorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerAddModeratorV1QueryOptions(id,setModeratorDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerRemoveModeratorV1Response204 {
  data: void
  status: 204
}

export type employeesControllerRemoveModeratorV1ResponseSuccess = (employeesControllerRemoveModeratorV1Response204) & {
  headers: Headers;
};
;

export type employeesControllerRemoveModeratorV1Response = (employeesControllerRemoveModeratorV1ResponseSuccess)

export const getEmployeesControllerRemoveModeratorV1Url = (id: string,
    moduleKey: string,) => {




  return `/api/v1/employees/${id}/moderator/${moduleKey}`
}

/**
 * @summary Снять модератора модуля (админ)
 */
export const employeesControllerRemoveModeratorV1 = async (id: string,
    moduleKey: string, options?: RequestInit): Promise<employeesControllerRemoveModeratorV1Response> => {

  return apiRequest<employeesControllerRemoveModeratorV1Response>(getEmployeesControllerRemoveModeratorV1Url(id,moduleKey),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getEmployeesControllerRemoveModeratorV1QueryKey = (id: MaybeRef<string>,
    moduleKey: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','employees',id,'moderator',moduleKey
    ] as const;
    }


export const getEmployeesControllerRemoveModeratorV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>, TError = unknown>(id: MaybeRef<string>,
    moduleKey: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerRemoveModeratorV1QueryKey(id,moduleKey);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>> = ({ signal }) => employeesControllerRemoveModeratorV1(unref(id),unref(moduleKey), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined && unref(moduleKey) !== null && unref(moduleKey) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>, TError, TData>
}

export type EmployeesControllerRemoveModeratorV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>>
export type EmployeesControllerRemoveModeratorV1QueryError = unknown


/**
 * @summary Снять модератора модуля (админ)
 */

export function useEmployeesControllerRemoveModeratorV1<TData = Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>, TError = unknown>(
 id: MaybeRef<string>,
    moduleKey: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerRemoveModeratorV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerRemoveModeratorV1QueryOptions(id,moduleKey,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerSetPhotoV1Response201 {
  data: void
  status: 201
}

export type employeesControllerSetPhotoV1ResponseSuccess = (employeesControllerSetPhotoV1Response201) & {
  headers: Headers;
};
;

export type employeesControllerSetPhotoV1Response = (employeesControllerSetPhotoV1ResponseSuccess)

export const getEmployeesControllerSetPhotoV1Url = (id: string,) => {




  return `/api/v1/employees/${id}/photo`
}

/**
 * @summary Загрузить фото сотрудника (админ)
 */
export const employeesControllerSetPhotoV1 = async (id: string,
    employeesControllerSetPhotoV1Body: EmployeesControllerSetPhotoV1Body, options?: RequestInit): Promise<employeesControllerSetPhotoV1Response> => {
    const formData = new FormData();
formData.append(`file`, employeesControllerSetPhotoV1Body.file);

  return apiRequest<employeesControllerSetPhotoV1Response>(getEmployeesControllerSetPhotoV1Url(id),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getEmployeesControllerSetPhotoV1QueryKey = (id: MaybeRef<string>,
    employeesControllerSetPhotoV1Body?: MaybeRef<EmployeesControllerSetPhotoV1Body>,) => {
    return [
    'POST', 'api','v1','employees',id,'photo', employeesControllerSetPhotoV1Body
    ] as const;
    }


export const getEmployeesControllerSetPhotoV1QueryOptions = <TData = Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>, TError = unknown>(id: MaybeRef<string>,
    employeesControllerSetPhotoV1Body: MaybeRef<EmployeesControllerSetPhotoV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getEmployeesControllerSetPhotoV1QueryKey(id,employeesControllerSetPhotoV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>> = ({ signal }) => employeesControllerSetPhotoV1(unref(id),unref(employeesControllerSetPhotoV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>, TError, TData>
}

export type EmployeesControllerSetPhotoV1QueryResult = NonNullable<Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>>
export type EmployeesControllerSetPhotoV1QueryError = unknown


/**
 * @summary Загрузить фото сотрудника (админ)
 */

export function useEmployeesControllerSetPhotoV1<TData = Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>, TError = unknown>(
 id: MaybeRef<string>,
    employeesControllerSetPhotoV1Body: MaybeRef<EmployeesControllerSetPhotoV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof employeesControllerSetPhotoV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEmployeesControllerSetPhotoV1QueryOptions(id,employeesControllerSetPhotoV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface employeesControllerGetPhotoUrlV1Response200 {
  data: PhotoUrlDto
  status: 200
}

export type employeesControllerGetPhotoUrlV1ResponseSuccess = (employeesControllerGetPhotoUrlV1Response200) & {
  headers: Headers;
};
;

export type employeesControllerGetPhotoUrlV1Response = (employeesControllerGetPhotoUrlV1ResponseSuccess)

export const getEmployeesControllerGetPhotoUrlV1Url = (id: string,) => {




  return `/api/v1/employees/${id}/photo-url`
}

/**
 * @summary Presigned-ссылка на фото сотрудника
 */
export const employeesControllerGetPhotoUrlV1 = async (id: string, options?: RequestInit): Promise<employeesControllerGetPhotoUrlV1Response> => {

  return apiRequest<employeesControllerGetPhotoUrlV1Response>(getEmployeesControllerGetPhotoUrlV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getEmployeesControllerGetPhotoUrlV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['employeesControllerGetPhotoUrlV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  employeesControllerGetPhotoUrlV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmployeesControllerGetPhotoUrlV1MutationResult = NonNullable<Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>>

    export type EmployeesControllerGetPhotoUrlV1MutationError = unknown

    /**
 * @summary Presigned-ссылка на фото сотрудника
 */
export const useEmployeesControllerGetPhotoUrlV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof employeesControllerGetPhotoUrlV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getEmployeesControllerGetPhotoUrlV1MutationOptions(options), queryClient);
    }
